import styles from './serviceAccountDetailsComponent.scss';
const ServiceAccountDetailsComponent = (props) => {
  let details = props.selectedAccount[0];
  let contractNumber = details.contractNumber;
  let houseNumber    = details.houseNumber;
  let strAddress     = (details.sreetAddress) ? (details.sreetAddress).toLowerCase():null;
  let city           =  (details.city) ? (details.city).toLowerCase() :null;
  let state          =  (details.state);
  let zipCode        =  (details.zipCode);
  let serviceAddress = details.serviceAddress;
  const serviceAccountDetailsJSX = 
  (props.selectedAccount.length === 1 && !props.selectAllFlow)?
   (<div className={styles.sceServiceAccInfoOuter}>
      <div className={styles.sceServiceAccInfo}>
        <div className='row'>
          <div className={'col-sm-12 col-xs-12'}>
         <div className={styles.serviceAccountDetails}><span className={styles.actInfo}>
            {houseNumber}{" "}{strAddress}{","}{" "}{city}{","}{" "}{state}{" "}{zipCode}</span>
            <span className={styles.accountData}>&nbsp;{"- Acct.  "}{contractNumber}</span>
          </div> 
          {/* <div>{" - Account Ending with"}{contractNumber}</div>  */}

          </div>
          {/* <div className='col-sm-4 col-xs-12 text-right'>
            
          </div> */}
        </div>
      </div>
    </div>)
    : 
    (<div className={styles.sceServiceAccInfoOuter}>
      <div className={styles.sceServiceAccInfo}>
        <div className='row'>
          <div className='col-sm-5 col-xs-12'>
       
            <p className={styles.sceServiceAccountDetails}>
            { props.selectAllFlow ? 
            props.unselectedAccountArray.length>0 ? <strong>{props.contractNumbercount - props.unselectedAccountArray.length +' service accounts'} </strong>:
            <strong>{props.contractNumbercount+' service accounts'} </strong>:
            <strong>{props.selectedAccount.length+' service accounts'} </strong>
           }
            </p>
          </div>
        </div>
      </div>
    </div>);
  return (
    <div>
      {serviceAccountDetailsJSX}
    </div>
  );
};

export default ServiceAccountDetailsComponent;
